export default "__VITE_ASSET__Bi7YfRm7__"